<template>
  <div>
    <v-dialog 
      v-model = "createReceiverDialog" 
      width="500">
      <v-card class="border-radius-standard">
        <v-card-title
          class="headline"
          primary-title
          style="font-size: 28px">
          {{ selected && selected.length && selected.length === 1 ? 'Rename Receiver' : 'Add New Receiver' }}
           <v-spacer />
           <v-icon @click="createReceiverDialog = false">close</v-icon>
        </v-card-title>
        <v-card-text>
          <add-receiver
            ref = "addReceiver"
            :dialog="createReceiverDialog"
            :put = "selected && selected.length && selected.length === 1 ? selected[0] : null"
            @loading = "addButtonLoader = $event"
            @success = "createReceiverDialog = false; getReceivers(false)">
              <label slot = "before-name" class="black--text" style="font-size: 16px">Receiver Name</label>
              <label slot = "before-number" class="black--text" style="font-size: 16px">Receiver Number</label>
              <!-- <label slot = "before-params" class="black--text" style="font-size: 16px">Parameters</label> -->
          </add-receiver>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            outline
            @click="createReceiverDialog = false">
            Cancel
          </v-btn>
          <v-btn
            :loading = "addButtonLoader"
            color="primary"
            @click="addNewReceiver">
            {{ selected && selected.length && selected.length === 1 ? 'Rename' : 'Add' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog 
      v-model = "deleteReceiverDialog" 
      width="400">
      <v-card v-if = "selected && selected.length" class="border-radius-standard">
        <v-card-title
          class="headline"
          primary-title>
          Delete {{ selected.map(receiver => receiver.name).join(', ') }}
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this Receiver?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color = "black"
            outline
            @click="deleteReceiverDialog = false">
            Cancel
          </v-btn>
          <v-btn
            :loading = "addButtonLoader"
            color="error"
            @click="deleteReceivers">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-flex xs12 class="px-0">
      <v-card class = "card-curvey pa-3">
        <v-layout 
          row 
          wrap>
          <v-flex xs12 class="px-0">
            <h3 class="mb-2 px-0 mx-0">Receivers One by One</h3>
          </v-flex>
          <v-flex xs4 class="pl-0">
            <v-text-field
              v-model = "queries.q"
              placeholder = "Search By Name.."
              intentend-icon = "search"
              outline
              @input="getReceivers(true)" />
          </v-flex>
          <v-spacer />
          <v-btn
            v-if="view === 'default'"
            :disabled="disabled"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click="downloadTemplate">
            <v-icon>download</v-icon>
            Receivers Template
          </v-btn>

          <v-btn
            v-if="view === 'default'"
            :loading = "!!(addButtonLoader && !selected.length)"
            color = "blue-grey"
            class = "nlp-nav-btn mr-0"
            small
            outline
            @click = "openAddDialog(true)">
            <v-icon>add</v-icon>
            Add Receiver
          </v-btn>

          <!-- <v-btn
            v-if="view !== 'default'"
            color = "blue-grey"
            class = "nlp-nav-btn mr-0"
            small
            outline
            @click = "exportReceivers">
            <v-icon>north</v-icon>
            Export
          </v-btn> -->

          <json-excel
            v-if="view !== 'default' && queriedReceivers && queriedReceivers.count"
            class="nlp-nav-btn v-btn blue-grey--text"
            style = "border: 1px solid"
            type = "csv"
            :name = "`Botter Campaign Receivers ${ $moment().format('YYYY-M-D hh mm') }.csv`"
            :fetch="setExportedReceivers"
            :before-generate="()=> { exportLoading = true }"
            :before-finish="()=> { exportLoading = false }" >
              <v-icon>north</v-icon>
              Export
          </json-excel>
          <v-btn
            v-else
            color = "blue-grey"
            class = "nlp-nav-btn"
            :loading = "exportLoading"
            :disabled="exportLoading"
            small
            outline
            disabled>
            <v-icon>north</v-icon>
            Export
          </v-btn>

        </v-layout>
        <v-flex xs12 class="px-0">
          <v-data-table
            v-if="queriedReceivers"
            :headers="headers"
            :items="queriedReceivers.receivers"
            :loading="loaders.list"
            item-key="name"
            hide-actions
            no-data-text = "No Receivers Available"
            class="elevation-1 nlp-data-table">
            <template 
              slot="items" 
              slot-scope = "props" > 
              <tr 
                v-if = "props.index === 0 && !props.item.name" 
                class = "text-center" 
                style="width: 100%">
                <td /><td /><td /><td class="text-center">No Receivers Available</td><td /><td />
              </tr>
              <tr v-if = "props.item.name">
                <td>
                  <span
                    class = "font-weight-bold">
                    {{ props.item.name }}
                  </span>
                </td>
                <td :class="[{ 'text-center' : view === 'default' }, { 'text-left': view !== 'default' }]">
                  {{ props.item.receiver_number }}
                </td>
                <td v-if="view !== 'default'" style="text-transform: capitalize;">
                  <span :class="[
                    { 'success--text' : props.item.state === 'SENT' },
                    { 'error--text' : props.item.state !== 'SENT' }
                  ]">
                    {{ props.item.state | titleCase }}
                  </span>
                </td>
                <td v-if="view !== 'default'" style="text-transform: capitalize;">
                  <span :class="[
                    { 'success--text' : firstStatus(props.item) === 'DELIVERED' },
                    { 'error--text' : firstStatus(props.item) === 'FAILED' },
                    { 'info--text' : firstStatus(props.item) === 'REPLY_BACK' },
                    { 'warning--text' : firstStatus(props.item) === 'PENDING' },
                  ]">
                    {{ firstStatus(props.item) | titleCase }}
                  </span>
                </td>
                <td
                  v-if="view === 'default'"
                  style="display: flex; justify-content: flex-end; align-items: center; padding-right: 0 !important;">
                	<v-tooltip bottom>
                		<template v-slot:activator="{ on }">
                			<v-btn v-on="on" class="px-3 receivers-small-actions-btn" @click="initDeleteReceiver(props.item)">
                				<span class="botter-trash-icon campain-small-action-bot-icon" style="color: #7F7F7F;" />
                			</v-btn>
                		</template>
                		<span>Delete</span>
                	</v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-divider />
      <v-layout 
        row 
        wrap >
        <v-flex xs10>
          <v-layout 
            justify-center 
            align-content-center 
            style = "padding-top: 15px">
            <v-pagination
              slot = "footer"
              v-model="pagination.page"
              :length="paginationCount"
              :disabled="loaders.list"
              style = "width: auto !important; margin: auto !important"
              @input = "getReceivers(false)" />
          </v-layout>
        </v-flex>
        <v-flex 
          xs2
          align-self-center>
          <v-spacer />
          <div style="text-align: right"><small>Items Per Page</small></div>
          <v-select
            v-model = "pagination.per_page"
            :items = "[5,10,15,20,25]"
            :disabled="loaders.list"
            style="width: 80px; float: right"
            outline
            @input = "getReceivers(false)"/>
        </v-flex>
      </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import AddReceiver from '@/components/campaign-manager/receivers-crud/AddReceiver.vue'
import SupportedPlatforms from '@/components/block-build/blocks/SupportedPlatforms.vue'
import fileDownload from 'js-file-download'
import JsonExcel from 'vue-json-excel'
export default {
  name: 'ReceiverList',
  components: {
    AddReceiver,
    SupportedPlatforms,
    JsonExcel
  },
  filters: {
    titleCase(val) {
      return val.toLowerCase().split('_').join(' ')
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      queries: {
        q: ''
      },
      pagination: {
        page: 1,
        per_page: 15
      },
      loaders: {
        list: false
      },
      createReceiverDialog: false,
      deleteReceiverDialog: false,
      addButtonLoader: false,
      selected: [],
      exportedReceivers: [],
      exportLoading: false,
    }
  },
  computed: {
    queriedReceivers() {
      return this.$store.state.campaigns.receivers
    },
    paginationCount() {
      return this.queriedReceivers && this.queriedReceivers.receivers && this.queriedReceivers.receivers.length
        ? Math.ceil(
            this.queriedReceivers.count /
              this.pagination.per_page
          )
        : 0
    },
    headers() {
      if(this.view === 'default') {
        return [
          {
            text: 'Receiver Name',
            align: 'left',
            sortable: false,
            value: 'receiver_number'
          },
          { text: 'Reciever Number', value: 'name', align: 'center' },
          { text: 'Actions', value: 'actions', align: 'right' },
        ]
      }
      return [
        {
            text: 'Receiver Name',
            align: 'left',
            sortable: false,
            value: 'receiver_number'
        },
        {
          text: 'Receiver Number',
          align: 'left',
          sortable: false,
          value: 'receiver_number'
        },
        { text: 'State', value: 'name', align: 'left', sortable: false },
        { text: 'Reply Back', value: 'actions', align: 'left', sortable: false },
      ]
    }
  },
  watch: {
    selected: {
      deep: true,
      handler(val) {
        if(val && val.length && val.length > 1) {
          this.selected = [val[val.length - 1]]
        }
      }
    }
  },
  mounted() {
    // get receivers
    this.getReceivers()
    if(this.$route.query.cb && this.$route.query.cb === 'add') {
      this.openAddDialog(true)
    }
  },
  methods: {
    firstStatus(item) {
      return item.status.length ? item.status[0].value : '-'
    },
    getReceivers(resetPagination = false) {
       this.loaders.list = true
      if(resetPagination) {
        this.pagination.page = 1
      }
      let params = { ...this.pagination, hideLoading: true, id: this.$route.params.id }
      if(this.queries.q && this.queries.q.length) params['filter[name]'] = this.queries.q

      this.$store.dispatch('receivers/get', params)
      .then(()=>{
        this.loaders.list = false
      })
      .catch(err => {
        this.$store.dispatch('setErrorMessage', true)
        this.loaders.list = false
        console.log(err)
      })
    },
    openAddDialog(reset = true) {
      if(reset)
        this.selected = []
      this.createReceiverDialog = true
    },
    addNewReceiver() {
      if (this.$refs.addReceiver) this.$refs.addReceiver.submit()
    },
    initEditReceiver(receiver) {
    	this.selected = [receiver]
    	this.openAddDialog(false)
    },
    initCopyReceiver(receiver) {
    	const inits = this.$_.pick(receiver, [ 'app'])
    	this.openAddDialog(true)
    	setTimeout(()=>{ this.$root.$emit('add-receiver-inits', inits) }, 500)
    },
    selectReceiver(receiver) {
      this.$store.dispatch('receivers/select', receiver)
      this.$router.push(`/receivers/${receiver._id}/editor`)
    },
    initDeleteReceiver(receiver) {
    	this.selected = [receiver]
    	this.deleteReceiverDialog = true
    },
    deleteReceivers() {
      this.$store.dispatch('setLoader', true)
      this.$store
        .dispatch('receivers/delete/single', this.selected[0]._id)
        .then(() => {
           this.$store.dispatch('setLoader', false)
          this.deleteTemplateMessageDialog = false
          this.deleteReceiverDialog = false
            this.$store.dispatch('setSnackbar', {
              text: `Deleted Successfully`,
              color: 'success'
            })
          this.selected = []
          this.getReceivers(false)
        })
        .catch((err) => {
          // console.log(err)
          this.$store.dispatch('setErrorMessage', true)
          this.$store.dispatch('setLoader', false)
        })
    },
    downloadTemplate() {
      this.$store.dispatch('setLoader', true)
      this.$http_chat.get(`/campaigns/${this.$route.params.id}/download-receivers-template`)
      .then(res => {
        this.$store.dispatch('setLoader', false)
        fileDownload(res.data, 'template.csv')
      })
      .catch((err) => {
          // console.log(err)
          this.$store.dispatch('setErrorMessage', true)
          this.$store.dispatch('setLoader', false)
        })
    },
    exportReceivers() {
      const arr = this.queriedReceivers.receivers.map(r => this.$_.pick(r, ['name', 'receiver_number', 'state', 'status']))
      this.downloadObjectAsJson(arr, 'campaign-receivers')
    },
    downloadObjectAsJson(exportObj, exportName) {
      const downloadUrl = window.URL.createObjectURL(new Blob([JSON.stringify(exportObj)]));
      const downloadAnchorNode = document.createElement('a');
      downloadAnchorNode.setAttribute('href', downloadUrl);
      downloadAnchorNode.setAttribute('download', exportName + '.botter.json');
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    },
    async setExportedReceivers() {
      try {
        this.$store.dispatch('setLoader', true)
        this.exportLoading = true;
        const all = await this.$http_chat.get(`/campaigns/${this.$route.params.id}/receivers`, { params: { per_page: this.queriedReceivers.count, page: 1 } })
        this.exportedReceivers = all.data.data.receivers.map(r => this.$_.pick(r, ['name', 'receiver_number', 'state', 'status'])).map(r => ({ ...r, status: this.firstStatus(r) }))
        return this.exportedReceivers
      } finally {
        this.exportLoading = false;
        this.$store.dispatch('setLoader', false)
      }
      
    }
  }
}
</script>

<style lang="scss" src="@/assets/sass/commponents/nlp.scss" />
<style lang="scss">
.receivers-small-actions-btn {
	height: 24px;
	width: 24px;
	max-width: 24px;
	min-width: 24px;
	border-radius: 3px !important;
	margin-left: 2px;
}
.campain-small-action-icon {
	font-size: 16px !important;
	margin-left: 4px;
  color: #7F7F7F !important;
}
.campain-small-action-bot-icon {
	font-size: 16px !important;
}
</style>
